import { render, staticRenderFns } from "./approvedHsbc.vue?vue&type=template&id=a89841da&scoped=true"
import script from "./approvedHsbc.vue?vue&type=script&lang=js"
export * from "./approvedHsbc.vue?vue&type=script&lang=js"
import style0 from "./approvedHsbc.vue?vue&type=style&index=0&id=a89841da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89841da",
  null
  
)

export default component.exports